import * as Html from "../util/Html.ts";
export {initDom}
Html.registerWidget('widget/video-load-detector',{initDom:initDom})

function initDom(node: HTMLElement){
  const videoNode = node as HTMLVideoElement;
  videoNode.onloadedmetadata = function(){
    // Déclencher un événement personnalisé 'afterupdate' avec la hauteur
    const event = new CustomEvent('afterupdate', {
      detail: videoNode.offsetHeight,
      bubbles: true
    });
    videoNode.dispatchEvent(event);
  }
}